export default __webpack_public_path__ + "static/media/instagram_plain.2109d311.svg";